import { ChevronUpChevronDownSFSymbolRegular } from '@/assets/sf-symbols/regular/chevron.up.chevron.down';
import { useT } from '@/utils/i18n';
import { useCodeBlockContext } from './context';

export const CodeBlockCollapseButton = () => {
  const t = useT();
  const { expandable, setExpanded } = useCodeBlockContext();

  return expandable ? (
    <button
      onClick={() => setExpanded(v => !v)}
      className="size-5.5 flex-center icon-button opacity-85"
      type="button"
      title={t('Toggle expand/collapse')}
    >
      <ChevronUpChevronDownSFSymbolRegular className="text-sm" />
    </button>
  ) : null;
};
